module.exports = __webpack_public_path__ + "img/xq1.696e203b.png";